<template>
    
    <div class="text-center">
      <!-- <v-container> -->
        <v-dialog v-model="showDialog" width="500" @click:outside="closeDialogAssinatura" >
          <v-card class="elevation-0" :disabled="$store.getters.dialogLoader" v-if="item">

              <v-card-title class="primary lighten-2">                
                  Plano de Assinatura
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeDialogAssinatura">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-card-title>
              <v-card-text class="pt-10">
              
                <v-row v-if="item != null">
                
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.fullName"
                      label="Aluno"
                      prepend-icon="mdi-account"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-select 
                      v-model="item.plano"
                      :error-messages="$v.item.plano.$invalid ? ['Selecione um plano'] : []"
                      :items="tipoList"
                      item-text="name"
                      label="Plano do aluno"
                      prepend-icon="mdi-card-account-details-outline"
                      return-object
                      outlined
                      dense
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="pt-0 pb-0" v-if="item.plano">
                    <v-checkbox label="Cobrar via app?" v-model="item.cobrancaApp"></v-checkbox>
                  </v-col>

                  <v-col cols="12" class="pt-0 pb-2 text-left body-2 text-justify" v-if="item.plano">
                    A cobrança via App é feita automaticamente, no cartão de crédito do cliente. Caso este campo não esteja marcado, 
                    o cliente não será cobrado. Deixe este campo livre caso seja um cliente antigo e você prefira receber por fora do App.
                  </v-col>

                  <v-col cols="12" v-if="item.plano">
                    <v-divider></v-divider>
                  </v-col>

                  <v-col cols="12" class="pt-2 pb-0 text-center body-1" v-if="item.plano">
                    <span class="">
                      <p v-if="item.plano.planType && item.plano.planType.indexOf('Semana') != -1">Este plano vale por {{item.plano.planType}}.</p>
                      <p v-if="item.plano.planType && item.plano.planType.indexOf('Semana') == -1">Este plano é {{item.plano.planType}}.</p>
                      <p>A inclusão do aluno no plano manualmente aqui não vai gerar cobrança imediata, mas quando este plano vencer, em {{item.plano.expirationDate}}, 
                        o aluno receberá um aviso por email, e poderá eventualmente acessar o app e pagar pela renovação.
                      </p>
                    </span>
                  </v-col>

                </v-row>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="primary"  @click="saveItem" :disabled="$v.item.$invalid || ((planoAtual && item.plano) && (item.plano.id == planoAtual.id))"> -->
                <v-btn color="primary"  @click="saveItem" :disabled="$v.item.$invalid">  
                  Atualizar
                  <v-icon right>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-card-actions>

          </v-card>
        </v-dialog>
        
      <!-- </v-container> -->

      
    </div>

</template>

<script>

import HOST from '../ws';
import { required } from "vuelidate/lib/validators";
import SnackBar from '../snackbar'



export default {

  props : {
    item : Object,
    planoAtual : Object,
    showDialog : Boolean, 
  },

  computed : {

  },

  data: () => ({

    myHost : HOST.HOST,
    errorMessage : null,

    tipoList : null,

  }),

  mounted() {

    this.errorMessage = null;
    const config = {
      headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
    };
    this.axios
      .post(this.myHost + "/plano/all", {}, config)
      .then(response => {
        this.tipoList = response.data;
        if(this.item && this.tipoList && (this.tipoList.length > 0)){
          this.item.planType = this.tipoList[0];
        }
      });

      
  },

  

  methods : {

    closeDialogAssinatura(){
      this.$emit('close-dialog-assinatura', false);
    },

    
    saveItem() {

      this.$store.commit("setDialogLoader", true);
      
      this.axios({
        method: "post",
        url: this.myHost + "/plano/updateuserplan",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.currentToken}`
        },
        data: JSON.stringify(this.item)
      }).then(response => {
        console.log("salvando item: " + response.status);
        this.$store.commit("setDialogLoader", false);
        this.closeDialogAssinatura();
        SnackBar.snackText = "Item salvo com sucesso";
        SnackBar.showSnack = true;
      });
    }
    

  },

  validations: {

    item: {
      plano: {
        required,
      },
      
    },
  }

};
</script>